export const list = {
  table: {
    exchange: '交換',
  },
  pageHeader: {
    title: 'アラート',
  },
}
